import React from 'react';
import Modal from './Modal';

const SpotCheckApprovalModal = ({ isOpen, handleClose, handleApprove, documentCount }) => {
    return (
        isOpen && (
            <Modal
                header="Are you sure you want to approve all documents?"
                handleClose={handleClose}
                cancelButton={{
                    label: "Cancel",
                    onClick: handleClose,
                }}
                confirmButton={{
                    label: "Approve and Publish",
                    variant: "positive",
                    onClick: handleApprove,
                }}
            >
                <p>
                    All <span className='font-weight-semi-bold'>{documentCount}</span> documents in this workflow will be approved and published. This action cannot be undone.
                </p>
            </Modal>
        )
    );
};

export default SpotCheckApprovalModal;